import { IAvaQuestTree, utils } from "@deltasge/marauders-map";
import { EmptyState } from "components/EmptyStates";
import { snack } from "components/GlobalSnackbar";
import { api } from "configs";
import { Main } from "pages/_layouts/Main";
import React, { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getError } from "utils";
import { Avaliacao } from "./components/Avaliacao";
import { useAppSelector, useAppDispatch } from "store";
import { request as getSistemaAvaliacao } from "store/modules/sistema-avaliacao";

export const Responder: FC = () => {
  const { id } = useParams<{ id?: string }>();
  const [loading, setLoading] = useState(false);
  const [ava, setAva] = useState<IAvaQuestTree | null>(null);

  const {
    sistemaAvaliacao: { data: sistemaAvaliacao, loading: loadingSistema },
    treeView: { cursos },
  } = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  useEffect(() => {
    (async () => {
      try {
        if (id) {
          setLoading(true);
          const { data } = await api.get<IAvaQuestTree | null>(
            `avaliacao-questionario/responder/${id}`
          );
          if (data) {
            const serie = utils.getSerieTreeView({
              cursos,
              idSerie: data.avaliacao.idSerie.toString(),
              idCurso: data.avaliacao.idCurso.toString(),
              type: undefined,
            });
            if (!serie || !serie.idSistemaAvaliacao) {
              throw new Error(
                "Serie ou ID do sistema de avaliação não encontrado"
              );
            }
            dispatch(getSistemaAvaliacao(serie.idSistemaAvaliacao));
          }
          setAva(data);
        }
      } catch (error) {
        snack.error(getError(error));
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const subtitle = ava?.avaliacao.questionario.nome;

  return (
    <Main
      title="Responder Avaliação"
      loading={loading || loadingSistema}
      subtitle={subtitle}
    >
      {!loading && !loadingSistema && !ava && (
        <EmptyState type="404" title="Nenhuma avaliação encontrada!" />
      )}
      {ava && sistemaAvaliacao && (
        <Avaliacao avaliacao={ava} sistemaAvaliacao={sistemaAvaliacao} />
      )}
    </Main>
  );
};
